import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
  namespaced: true,
  state: {
    objs: []
  },
  getters: {
    ...functions.createDefaultGetters(['work', 'user', 'card']),
    getByWork: state => work => {
      return state.objs.filter(ec => ec.work === work);
    },
    getByUser: state => user => {
      return state.objs.filter(ec => ec.user === user);
    },
    getByEmployment: state => (work, user) => {
      return state.objs.filter(ec => ec.work === work && ec.user === user);
    },
    getByCard: state => card => {
      return state.objs.filter(ec => ec.card === card);
    }
  },
  mutations: {
    ...functions.createDefaultMutations(['work', 'user', 'card']),
  },
  actions: {
    ...functions.createDefaultActionsWithStore(['work', 'user', 'card'])
  },
}